import React from "react";
import { useTheme } from "@mui/material/styles";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, Grid, Modal, Typography } from "@mui/material";
import useButtonStyles from "../../styles/useButtonStyles";

interface TimeOutModalProps {
  onClose: () => void;
}

const TimeOutModal: React.FC<TimeOutModalProps> = ({ onClose }) => {
  const theme = useTheme();
  const buttonStyles = useButtonStyles();

  return (
    <Grid>
      <Modal
        open={true}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "none",
          outline: "none",
          "&:focus": {
            outline: "none",
          },
        }}
      >
        <Grid
          sx={{
            background: theme.color?.background,
            width: "30%",
            height: "auto",
            px: 6,
            borderRadius: "8px",
            py: 4,
          }}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid>
            <ErrorOutlineIcon fontSize="large" style={{ color: "red" }} />
          </Grid>

          <Typography
            id="modal-modal-title"
            variant="h6"
            textAlign={"center"}
            sx={{
              color: theme?.color?.dark,
              fontWeight: 550,
              fontFamily: theme?.font?.fontFamily.primary,
              letterSpacing: 0.7,
              fontSize: 14,
              mt: 2,
              mb: 4,
            }}
          >
            Your session will expire in 60 seconds.
          </Typography>
          <Button
            type="submit"
            onClick={onClose}
            sx={{ ...buttonStyles.containedSecondary, width: "50%" }}
          >
            OK
          </Button>
        </Grid>
      </Modal>
    </Grid>
  );
};

export default TimeOutModal;
